import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { RootState } from '../../store'
import { BankDetailsForm } from './bank-details-form'
import { kycServices } from '../../services/kyc-service'

const BankDetailsContainer = () => {
  const { authToken, userId } = useSelector((state: RootState) => state.investor)
  const [initialValues, setInitialValues] = useState({
    beneficiaryName: '',
    accountNumber: '',
    beneficiaryBank: '',
    bankAddress: '',
    cif: '',
    swiftCode: '',
  })

  useEffect(() => {
    const fetchBankDetails = async () => {
      const data = await kycServices.getInvestorBankDetails(userId, {
        Authorization: authToken ? authToken : '',
      })
      if (data && data.data && data.status === 200) {
        setInitialValues(data.data)
      }
    }
    if (authToken) fetchBankDetails()
  }, [authToken, userId])

  return <BankDetailsForm initialValues={initialValues} />
}

export { BankDetailsContainer }
